import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getPopular = createAsyncThunk("popular/getPopular", async () => {
  const API_URL = "https://api.themoviedb.org/3";
  const API_KEY = "ae4dbdc73a2bf042cb271a0b322631d5";
  try {
    const popular = await axios.get(`${API_URL}/movie/popular`, {
      params: {
        api_key: API_KEY,
        page: 2,
      },
    });

    return popular.data.results;
  } catch (error) {
    console.log(error);
  }
});

export const postPopularSlice = createSlice({
  name: "popular",
  initialState: {
    popular: [],
    loading: false,
  },
  reducers: {},
  extraReducers: {
    [getPopular.pending]: (state) => {
      state.loading = true;
    },
    [getPopular.fulfilled]: (state, action) => {
      state.loading = false;
      state.popular = action.payload;
    },
    [getPopular.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const postPopular = postPopularSlice.reducer;
